export let baseURL = "http://komet.test";

if (process.env.NODE_ENV === "production") {
    baseURL = "https://api.kometinstitut.online";
}

export const dateOptions = { weekday: "long", year: "numeric", month: "short", day: "numeric" };

export const config = {
    baseURL,
    dateOptions,
};
export default config;
